<template>
  <div v-if="isSettingPage()" class="cl-layout">
    <LayoutComponent @toggle="toggleSidebar" ref="layoutRef" />
    <div class="cl-main">
      <AppBarComponent
        :language="lang"
        :multilang="multilang"
        @langchange="languageChange"
        @logout="logOut"
        @toggle="toggleSidebar"
      />
      <div class="cl-content">
        <router-view />
      </div>
    </div>
  </div>
  <div v-else>
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import LayoutComponent from './components/common/LayoutComponent.vue';
import AppBarComponent from './components/organisms/AppBarComponent.vue';

export default defineComponent({
  components: {
    LayoutComponent,
    AppBarComponent,
  },
  setup() {
    const layoutRef = ref<InstanceType<typeof LayoutComponent> | null>(null);
    function toggleSidebar() {
      layoutRef.value?.toggleSidebar();
    }
    return { layoutRef, toggleSidebar };
  },
  data() {
    return {
      lang: 'EN',
      multilang: { en: true, se: false } as { en: boolean; se: boolean },
    };
  },
  mounted() {
    this.$i18n.locale = 'en';
    this.multilang = { en: true, se: false };
    this.lang = this.$i18n.locale.toUpperCase();
  },
  methods: {
    isSettingPage() {
      return this.$route.path !== '/register'
        && this.$route.path !== '/login'
        && this.$route.path !== '/forget-password'
        && this.$route.path !== '/recoverPassword';
    },
    languageChange(code: string) {
      this.$i18n.locale = code;
      this.lang = code.toUpperCase();
      this.multilang = { en: false, se: false };
      if (code === 'en') this.multilang = { en: true, se: false };
      if (code === 'se') this.multilang = { en: false, se: true };
    },
    logOut() {
      import('./services/authService').then(m => m.default.removeJwtUser());
      this.$router.push('/login');
    },
  },
});
</script>